import React from 'react';
import { toast } from 'react-toastify';
import { ModalBody, ModalFooter } from '../../../../components/Modal/styles';
import Button from '../../../../components/Button';
import { LoadingSpinner } from '../../../../components/Loading/styles';
import Modal from '../../../../components/Modal';
import { ModalProps } from '../OwnerPage/OwnerPage';
import { familyApi } from '../../../../services/family-api';
import { Actions, Categories } from '../../../../types/gtm';

const RemoveModal = ({
  user,
  modal,
  loading,
  setModal,
  setLoading,
  close,
}: ModalProps) => {
  const label = 'Tela Remover Dependente';
  const labelPost = 'Tela Dependente Removido';

  async function remove() {
    setLoading(true);
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.FamilyOwner,
      event_action: Actions.ClickRemoveDependent,
      event_label: label,
      bd_suser_code: user?.globoId,
    });

    await familyApi
      .delete('/v1/fe/user/granted/remove', {
        data: { GrantedID: modal.globoId, Origin: 'Exclusão pelo Titular' },
      })
      .then(response => {
        window.dataLayer.push({
          event: 'customEventUserInteraction',
          event_category: Categories.FamilyOwner,
          event_action: Actions.Success,
          event_label: labelPost,
          bd_suser_code: user?.globoId,
        });

        setLoading(false);
        setModal({ ...modal, alreadyRequest: true });

        if (response.status !== 204) {
          toast.error('Ocorreu um erro ao remover dependente');
          close(false);
        }
      })
      .catch(() => {
        setLoading(false);
        toast.error('Ocorreu um erro ao remover dependente');
        close(false);
      });
  }

  return (
    <Modal header="Remover dependente?">
      <ModalBody>
        {!modal.alreadyRequest ? (
          <>
            <p>
              <b>{modal.name}</b>
              <br />
              {modal.email}
            </p>
            <p>
              Ao remover esse dependente, ele não terá mais acesso aos conteúdos
              que você compartilha com a sua família.
            </p>
          </>
        ) : (
          <p>
            Você removeu <b>{modal.email}</b> da sua família.
          </p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary"
          onClick={() =>
            close(
              modal.alreadyRequest,
              modal.alreadyRequest ? labelPost : label,
            )
          }
        >
          Fechar
        </Button>
        {!modal.alreadyRequest && (
          <Button variant="secondary" width="100%" onClick={() => remove()}>
            {loading ? <LoadingSpinner isButton /> : 'Remover'}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default RemoveModal;
